module.exports = __webpack_public_path__ + "img/103.6857d9ea.jpg";